import React from 'react';

import { Skeleton } from '@/components/ui/Skeleton';

export const HeroSkeleton: React.FC = () => {
  return (
    <section className="bg-black">
      <div className="relative w-full h-[60vh] md:h-[70vh] overflow-hidden border-b border-neutral-800">
        {/* Background skeleton */}
        <Skeleton className="absolute inset-0 rounded-none" shimmer />

        {/* Gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />

        {/* Content skeleton - same box model as FeaturedHero so nothing jumps on load */}
        <div className="absolute bottom-0 left-0 w-full pb-10 md:pb-12 z-20">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="max-w-4xl space-y-4">
              {/* Badge */}
              <Skeleton variant="rectangular" width="180px" height="28px" />

              {/* Title */}
              <div className="space-y-2 pt-1">
                <Skeleton variant="text" height="36px" width="90%" className="md:h-16" />
                <Skeleton variant="text" height="36px" width="70%" className="md:h-16" />
              </div>

              {/* Excerpt */}
              <div className="space-y-2">
                <Skeleton variant="text" width="80%" />
                <Skeleton variant="text" width="60%" />
              </div>

              {/* CTA Button */}
              <Skeleton variant="rectangular" width="180px" height="48px" className="mt-2" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
